import { atom } from 'jotai';
import { ILocation } from '@shared/types.ts';

export const citiesAtom = atom<ILocation[]>([]);

export const cityAtom = atom<{
  id: number;
  name: string;
}>({
  id: 0,
  name: '',
});
